import React, { Component } from 'react';
import styled from 'styled-components';
import { ImgOverlayContainer } from '../../../theme/assets';
import { SideColumn, MobileHide } from '../../../theme/grid';
import { ButtonShow } from '../../../theme/buttons';

const BaseImage = styled.div`
    img {
      box-shadow: 0 2px 12px 0px #c4cad0;
    }
`;

class Layout extends Component {
  constructor() {
    super();
    this.state = {
      gridOverlay: true,
      gridRedlines: false,
      gridMultipleColumns: false,
      selectedOverlay: 'selected',
      selectedRedlines: '',
      selectedMultipleColumns: ''
    }
  }
  showGridOverlay(e){
    e.preventDefault();
    const { gridOverlay } = this.state;
    this.setState({
      gridOverlay: !gridOverlay
     })
     if (gridOverlay === false) {
       this.setState({
         selectedOverlay: 'selected'
       })
     } else {
       this.setState({
         selectedOverlay: ''
       })
     }
  }
  showGridRedlines(e){
    e.preventDefault();
    const { gridRedlines } = this.state;
    this.setState({
      gridRedlines: !gridRedlines
     })
     if (gridRedlines === false) {
       this.setState({
         selectedRedlines: 'selected'
       })
     } else {
       this.setState({
         selectedRedlines: ''
       })
     }
  }
  showGridMultipleColumns(e){
    e.preventDefault();
    const { gridMultipleColumns } = this.state;
    this.setState({
      gridMultipleColumns: !gridMultipleColumns
     })
     if (gridMultipleColumns === false) {
       this.setState({
         selectedMultipleColumns: 'selected'
       })
     } else {
       this.setState({
         selectedMultipleColumns: ''
       })
     }
  }

  render() {
    return (
      <div>
        <MobileHide>
          <SideColumn>
            <h4>Display</h4>
            <ButtonShow className={this.state.selectedOverlay} onClick={this.showGridOverlay.bind(this)}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><ellipse class="light" cx="12" cy="12" fill="#C0DDFF" rx="10" ry="7"/><circle class="dark" cx="12" cy="12" r="4" fill="#07F"/><circle cx="15" cy="9" r="2" fill="#FFF"/></g></svg><span>Columns</span></ButtonShow>
            <ButtonShow className={this.state.selectedRedlines} onClick={this.showGridRedlines.bind(this)}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><ellipse class="light" cx="12" cy="12" fill="#C0DDFF" rx="10" ry="7"/><circle class="dark" cx="12" cy="12" r="4" fill="#07F"/><circle cx="15" cy="9" r="2" fill="#FFF"/></g></svg><span>Rows</span></ButtonShow>
            <ButtonShow className={this.state.selectedMultipleColumns} onClick={this.showGridMultipleColumns.bind(this)}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><ellipse class="light" cx="12" cy="12" fill="#C0DDFF" rx="10" ry="7"/><circle class="dark" cx="12" cy="12" r="4" fill="#07F"/><circle cx="15" cy="9" r="2" fill="#FFF"/></g></svg><span>Grid</span></ButtonShow>
          </SideColumn>
        </MobileHide>
        <ImgOverlayContainer>

          <BaseImage>
            <img alt="" src={require('../../../assets/ProgressComponents/Layout/dashboard@2x.png')} width="100%" />
          </BaseImage>

          {this.state.gridOverlay && <div>
            <img alt="" src={require('../../../assets/ProgressComponents/Layout/columns@2x.png')} width="100%" />
          </div> }
          
          {this.state.gridRedlines && <div>
            <img alt="" src={require('../../../assets/ProgressComponents/Layout/rows@2x.png')} width="100%" />
          </div> }
          
          {this.state.gridMultipleColumns && <div>
            <img alt="" src={require('../../../assets/ProgressComponents/Layout/grid@2x.png')} width="100%" />
          </div> }

        </ImgOverlayContainer>

      </div>
    );
  }
}

export default Layout;



// WEBPACK FOOTER //
// src/assets/ProgressComponents/Layout/Layout.js